import { types } from "../actions/shoppingCart";

const initialState = {
  cart: JSON.parse(localStorage.getItem("cart")) || {},
};

const shoppingCartReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_ITEM_TO_CART:
      const { item, quantity } = payload;
      const { cart } = state;
      if (cart[item.id]) {
        cart[item.id].quantity += quantity;
        if (cart[item.id].quantity === 0) delete cart[item.id];
      } else if (quantity > 0) {
        cart[item.id] = { ...item, quantity };
      }
      localStorage.setItem("cart", JSON.stringify(cart));
      return {
        ...state,
        cart,
      };

    case types.UPDATE_ITEM: {
      const { value, key, type } = payload;
      const { cart } = state;
      if (cart[key]) {
        if (type === "balanceTransfer") {
          cart[key].balance_transfer.discount = value;
        } else if (type === "cashCard") {
          cart[key].cash_card.discount = value;
        }
      }
      localStorage.setItem("cart", JSON.stringify(cart));
      return {
        ...state,
        cart,
      };
    }

    /** Reducer use it in product detail */
    case types.REMOVE_ITEM_FROM_CART: {
      const { item } = payload;
      const { cart } = state;
      delete cart[item.id];
      localStorage.setItem("cart", JSON.stringify(cart));
      return { ...state, cart };
    }

    case types.EMPTY_CART: {
      localStorage.removeItem("cart");
      return { ...state, cart: {} };
    }

    default:
      return state;
  }
};

export default shoppingCartReducer;
